import React from 'react';

function Contact() {
    return (
        <div>
          <div>
            <div className="home_three_container">        
            <div>
              {/*breadcrumbs area start*/}
              <div className="breadcrumbs_area">
                <div className="container">   
                  <div className="row">
                    <div className="col-12">
                      <div className="breadcrumb_content">
                        <h3>Contact</h3>
                        <ul>
                          <li><a href="/">home</a></li>
                          <li>Contact</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>         
              </div>
            </div>
            </div>
          </div>

          <div className="contact_area pt-5 pb-0">
            <div className="container">   
              <div className="row">
                <div className="col-lg-6 col-md-6">
                  <div className="contact_message content">
                    <h3>contact us</h3>    
                      <div className="header_social text-right">
                          <ul>
                              <li><a href="https://www.youtube.com/@findmejoinme"><i className="ion-social-youtube-outline" /></a></li>
                              <li><a href="https://www.facebook.com/findmejoinme"><i className="ion-social-facebook" /></a></li>
                              <li><a href="https://www.instagram.com/findmejoinme"><i className="ion-social-instagram-outline" /></a></li>
                              <li><a href="https://www.tiktok.com/@findmejoinme"><i className="fab fa-tiktok" /></a></li>
                          </ul>
                      </div>           
                  </div> 
                </div>
              </div>
            </div>    
          </div>
        </div>
    )
}
export default Contact;
